const UserMenuComponent = {
    templateUrl: '/ui/user/menu/userMenu.tpl.html',
    controller: 'userMenuController',
    bindings: {
        userId: '<',
        defaultSelectedValue: '<',
        onSelectedItemChange: '&',
        onMenuHasSingleItem: '&',
        onMenuHasMultipleItems: '&'
    }
};

angular.module('umCore')
    .component('uiUserMenu', UserMenuComponent);
